import React from "react";
import { get } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
const SchemaSnippet = _ref => {
  let {
    fields
  } = _ref;
  var _item$sameAs, _item$typeName, _item$nameValue, _item$logo;
  const sitecoreContext = useSitecoreContext();
  const canonicalUrl = get(sitecoreContext, 'canonical', "");
  const originBaseUrl = get(sitecoreContext, 'origin', "");
  const item = fields.data.item || [];
  const sameAsLinks = Array.isArray((_item$sameAs = item.sameAs) === null || _item$sameAs === void 0 ? void 0 : _item$sameAs.targetItems) ? item.sameAs.targetItems.map(target => {
    var _target$link;
    return (_target$link = target.link) === null || _target$link === void 0 || (_target$link = _target$link.jss) === null || _target$link === void 0 || (_target$link = _target$link.value) === null || _target$link === void 0 ? void 0 : _target$link.url;
  }).filter(url => typeof url === "string" && url.length > 0) : [];
  const schemaData = {
    "@context": "https://schema.org",
    "@type": ((_item$typeName = item.typeName) === null || _item$typeName === void 0 || (_item$typeName = _item$typeName.jss) === null || _item$typeName === void 0 ? void 0 : _item$typeName.value) || "",
    "name": ((_item$nameValue = item.nameValue) === null || _item$nameValue === void 0 || (_item$nameValue = _item$nameValue.jss) === null || _item$nameValue === void 0 ? void 0 : _item$nameValue.value) || "",
    "url": canonicalUrl
  };
  if ((_item$logo = item.logo) !== null && _item$logo !== void 0 && (_item$logo = _item$logo.targetItem) !== null && _item$logo !== void 0 && (_item$logo = _item$logo.logoImage) !== null && _item$logo !== void 0 && (_item$logo = _item$logo.jss) !== null && _item$logo !== void 0 && (_item$logo = _item$logo.value) !== null && _item$logo !== void 0 && _item$logo.src) {
    schemaData.logo = `${originBaseUrl}/${item.logo.targetItem.logoImage.jss.value.src}`;
  }
  if (sameAsLinks.length > 0) {
    schemaData.sameAs = sameAsLinks;
  }
  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(schemaData, null, 2)
    }
  });
};
export default SchemaSnippet;